import { formatCurrency } from 'helpers/common';
import { IManageShopSubscriptionPlan } from 'models/shop/shopprofile';
import * as React from 'react';
import { momentWithTimezone } from 'redux/modules/shop/helpers';

require('./style.scss');

export default function ShopSmsReport({ t, shop }) {
	const timezone: string = shop?.offices?.length ? shop.offices[0].zoneInfo : undefined;
	const shopSubPlan: IManageShopSubscriptionPlan = shop?.currentShopSubscriptionPlan;
	let priceToPayString: string = '0';

	if (
		shopSubPlan?.smsPrice &&
		shopSubPlan?.total &&
		shopSubPlan?.freeSmss !== null &&
		shopSubPlan?.total > shopSubPlan?.freeSmss
	) {
		const numberOfSmssOver = shopSubPlan.total - shopSubPlan.freeSmss;
		const priceToPay = parseFloat((shopSubPlan.smsPrice * numberOfSmssOver).toFixed(2));
		priceToPayString = formatCurrency(shopSubPlan.currencyKey, priceToPay);
	}

	return shopSubPlan ? ( // Show sms info only if a plan exists
		<div className="row shopSmsReport">
			<div className="col-md-6">
				<div className="shopSmsReport__smsCount">
					<p className="shopSmsReport__smsCountText">{t('Shop_ManageShop_General_Label_SentTextMessages')}</p>
					<p>
						<span className="shopSmsReport__smsUsed">{shopSubPlan?.total}</span>{' '}
						{/** Sms messages used in the current subscription plan */}
						{shopSubPlan?.freeSmss ? <span className="shopSmsReport__divider">/</span> : null}
						{shopSubPlan?.freeSmss ? (
							<span className="shopSmsReport__shopSubscriptionTotal">{shopSubPlan?.freeSmss}</span>
						) : null}{' '}
						{/** Total sms messages in current subscription plan */}
					</p>

					<p className="shopSmsReport__smsResetDate">
						{t('Shop_ManageShop_General_Label_ResetsOn')}{' '}
						{momentWithTimezone(timezone, shopSubPlan?.validTo).format('ll')}
					</p>
				</div>
			</div>

			<div className="col-md-6">
				<div className="shopSmsReport__smsAdditionalCost">
					<p className="shopSmsReport__smsCountText">{t('Shop_ManageShop_General_Label_AdditionalCosts')}</p>
					<p>
						<span className="shopSmsReport__smsPrice">{priceToPayString}</span>
					</p>
				</div>
			</div>
		</div>
	) : null;
}
